import React from 'react';
import './ApexInfoBlocks.css';
import fullkit from './assets/octane.png';
import { FaShieldAlt, FaDiscord, FaShoppingCart } from 'react-icons/fa';
import { RiGitRepositoryPrivateFill } from "react-icons/ri";
import { VscCompassActive } from "react-icons/vsc";
import { GiAk47 } from "react-icons/gi";
import { HiOutlineSquaresPlus } from "react-icons/hi2";
import { BsNvidia } from "react-icons/bs";
import { useTranslation } from 'react-i18next';

const ApexInfoBlocks = () => {
  const { t } = useTranslation();

  return (
    <div className="apex_info-blocks-wrapper">
      <h2 className="apex_info-blocks-heading">{t('apex_info_blocks_heading')}</h2>
      <p className="apex_features-header-text">{t('apex_features_header_text')}</p>

      {/* Erste Zeile */}
      <div className="apex_info-blocks-container">
        <div className="apex_info-block">
          <h3><FaShieldAlt className="apex_info-icon" /> {t('apex_undetected')}</h3>
          <p>{t('apex_undetected_desc')}</p>
        </div>
        <div className="apex_info-block">
          <h3><RiGitRepositoryPrivateFill className="apex_info-icon" /> {t('apex_private_builds')}</h3>
          <p>{t('apex_private_builds_desc')}</p>
        </div>
        <div className="apex_info-block">
          <h3><HiOutlineSquaresPlus className="apex_info-icon" /> {t('apex_hotkeys')}</h3>
          <p>{t('apex_hotkeys_desc')}</p>
        </div>
      </div>

      {/* Zweite Zeile */}
      <div className="apex_info-blocks-container apex_second-row">
        <div className="apex_info-block">
          <h3><GiAk47 className="apex_info-icon" /> {t('apex_all_weapons')}</h3>
          <p>{t('apex_all_weapons_desc')}</p>
        </div>
        <div className="apex_info-block">
          <h3><FaDiscord className="apex_info-icon" /> {t('apex_discord_support')}</h3>
          <p>{t('apex_discord_support_desc')}</p>
        </div>
        <div className="apex_info-block">
          <h3><VscCompassActive className="apex_info-icon" /> {t('apex_active_development')}</h3>
          <p>{t('apex_active_development_desc')}</p>
        </div>
      </div>

      {/* Dritte Zeile (nur noch ein Block) */}
      <div className="apex_info-blocks-container apex_second-row">
        <div className="apex_info-block">
          <h3><BsNvidia className="apex_info-icon" /> {t('apex_cloud_gaming')}</h3>
          <p>{t('apex_cloud_gaming_desc')}</p>
        </div>
      </div>

      {/* Purchase-Button */}
      <div className="apex_purchase-button-container">
        <button
          className="apex_purchase-button"
          onClick={() => { window.location.href = "#pricing"; }}
        >
          <FaShoppingCart className="apex_purchase-icon" />
          <span>{t('apex_purchase_to_download')}</span>
        </button>
      </div>

      {/* Hintergrundbild, außerhalb des Contents */}
      <img src={fullkit} alt="Apex Legends Full Weapon Arsenal - All Supported Guns" className="apex_info-blocks-bg" loading="lazy" />
    </div>
  );
};

export default ApexInfoBlocks;